export default __webpack_public_path__ + "assets/models/99b0611a18af0760015c18b3b6c582e0.glb";